// import { PageContainerProps } from './page-container.types'
import styles from './page-container.module.scss'
import cl from 'classnames'
import {
  PageContainer as PanelPageContainer,
  PageContainerProps
} from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'

const PageContainerComponent = (props: PageContainerProps) => {
  const { className, ...rest } = props,
  {
    routingStore: {
      location: { pathname }
    }
  } = useRootStore()

  const activeContainerStyle = (pathname === '/stores' ? 'container' : '');

  return (
    <PanelPageContainer className={cl(styles.container, className, activeContainerStyle)} {...rest} />
  )
}

const PageContainer = PageContainerComponent
export { PageContainer }
